<script>
import graphApexChart from "../../dashboard/GraphApexChart.vue";
export default {
  template: `
    <div class="box">
      <h1>{{title}}</h1>
      <graph-apex-chart v-if='dataGraph' :data='dataGraph'></graph-apex-chart>
    </div>
  `,
  data: function() {
    return {
      type: {
        apoyod: ["apsd", "vincd", "apod"],
        calidadd: ["excd", "cycd", "segd"],
        innovaciond: ["autd", "agid", "mejd"],
        metasd: ["logrd", "servd", "repd"],
      },
      title: "",
      quadrant: "",
      dataGraph: {},
    };
  },
  props: {
    nameQuadrants: {
      type: Object,
      required: true,
    },
    nameRanges: {
      type: Object,
      required: true,
    },
    getRange: {
      type: Function,
      required: true,
    },
  },
  beforeMount() {
    const params = this.$parent.params;
    this.title = params.colDef.headerName;
    this.quadrant = params.colDef.field;
    this.dataGraph = this.createDataGraphHorizontalBar(params.data);
  },
  methods: {
    createDataGraphHorizontalBar: function(data) {
      const paddingLeft = {
        apoyod: 75,
        calidadd: 65,
        innovaciond: 55,
        metasd: 55,
      };
      let graph = {
        series: [
          {
            name: "Actual",
            data: [
              {
                x: "Datos",
                y: 12,
                goals: [
                  {
                    name: "Anterior",
                    value: 14,
                    strokeWidth: 2,
                    strokeDashArray: 2,
                    strokeColor: "#775DD0",
                  },
                ],
              },
            ],
          },
        ],
        options: {
          chart: {
            width: "100%",
            height: "100%",
            redrawOnParentResize: true,
            redrawOnWindowResize: false,
            type: "bar",
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4,
              distributed: true,
              colors: {
                backgroundBarColors: ["#f9f8f8"],
              },
            },
          },
          grid: {
            show: false,
            padding: {
              top: 0,
              right: 10,
              bottom: 10,
              left: paddingLeft[this.quadrant],
            },
          },
          colors: [],
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: false,
          },
          xaxis: {
            min: 0,
            max: 100,
          },
          yaxis: {
            position: "left",
            labels: {
              align: "right",
            },
          },
          legend: {
            show: false,
          },
        },
        width: "280",
        height: "120",
        type: "bar",
      };
      if (data) {
        const colors = [
          "#a5a5a5",
          "#76be7c",
          "#d9ead3",
          "#fde8af",
          "#f5bc95",
          "#fda0a0",
        ];
        const labels = this.type[this.quadrant];
        const dataG = labels.map((x) => {
          const v = data[x].p | 0;
          const vComp = Object.keys(data.comparison).length
            ? data.comparison[x].p | 0
            : 0;
          const d = {
            x: this.nameQuadrants[x],
            y: v,
          };

          if (data.comparison && vComp) {
            d.goals = [
              {
                name: "Anterior",
                value: vComp,
                strokeWidth: 2,
                strokeDashArray: 2,
                strokeColor: "#000000",
              },
            ];
          }

          graph.options.colors.push(colors[this.getRange(v)]);
          return d;
        });
        graph.series[0].data = dataG;
      }
      return graph;
    },
  },
  components: {
    graphApexChart,
  },
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/climan/components/tooltipGraphBarHClima.vue